import { Component, Inject, OnInit, ViewChild } from '@angular/core'
import { FormBuilder, FormGroup, Validators } from '@angular/forms'
import { Store } from '@ngrx/store'
import { ActionFailed, noAllWhitespaceValidator, SaveForm, Toaster } from '@tokeet-frontend/tv3-platform'
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog'
import { finalize } from 'rxjs/operators'
import { AddCreditCard, ReplaceCreditCard } from '../store/card/card.actions'
import { AddCreditCardRequest } from '../store/card/card.model'
import { StripeCreditCardFormComponent } from '../stripe-credit-card-form/stripe-credit-card-form.component'
import { StripeAPIError } from '../stripe-credit-card-form/stripe.model'
import { HttpErrorResponse } from '@angular/common/http'

@Component({
  selector: 'app-add-credit-card-dialog',
  templateUrl: './add-credit-card-dialog.component.html',
  host: { class: 'modal-content' },
  styleUrls: ['./add-credit-card-dialog.component.scss'],
})
export class AddCreditCardDialogComponent implements OnInit {
  @ViewChild('stripeCardForm') stripeCardForm: StripeCreditCardFormComponent

  form = this.fb.group({
    firstName: ['', [Validators.required, noAllWhitespaceValidator]],
    lastName: ['', [Validators.required, noAllWhitespaceValidator]],
    terms: [0],
  })

  processing = false

  constructor(
    public dialogRef: MatDialogRef<AddCreditCardDialogComponent>,
    private fb: FormBuilder,
    private toaster: Toaster,
    private store: Store<any>,
    @Inject(MAT_DIALOG_DATA) public data: { replace: boolean }
  ) {}

  ngOnInit() {}

  close() {
    this.dialogRef.close()
  }

  @SaveForm()
  save(form: FormGroup) {
    const formData = form.getRawValue()
    this.processing = true
    this.stripeCardForm
      ?.handleCardSetup({
        name: `${formData.firstName} ${formData.lastName}`,
      })
      .pipe(finalize(() => (this.processing = false)))
      .subscribe(
        (setupIntent) => {
          const request = { setup_intent: setupIntent, replace: this.data.replace } as AddCreditCardRequest
          if (this.data.replace) {
            this.store.dispatch(ReplaceCreditCard({ request }))
          } else {
            this.store.dispatch(AddCreditCard({ request }))
          }
          this.close()
        },
        (error: StripeAPIError | HttpErrorResponse) => {
          if (error instanceof HttpErrorResponse) {
            this.toaster.error($localize`Error authenticating card.`)
          } else {
            this.store.dispatch(ActionFailed({ error: new Error(error.message) }))
          }
        }
      )
  }
}
